module.exports = __webpack_public_path__ + "img/features-bg_17.e8125117.png";